import { render, staticRenderFns } from "./FeaturedButton.vue?vue&type=template&id=167ee024&scoped=true&"
import script from "./FeaturedButton.vue?vue&type=script&lang=js&"
export * from "./FeaturedButton.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedButton.vue?vue&type=style&index=0&id=167ee024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ee024",
  null
  
)

export default component.exports